<template>
  <div class="image-upload-card-wrraper-initial">
    <input
      :id="id"
      :accept="accept"
      :multiple="multiple"
      :tabindex="tabindex"
      type="file"
      class="image-upload-input"
      @change="onImageSelected"
    />
    <div class="image-upload-card-inner-initial">
      <FIcon :name="'image-upload'" size="1.8rem" color="#42c3fe" />
    </div>
    <p class="image-upload-text">{{ $t("upload_image_label") }}</p>
  </div>
</template>

<script>
export default {
  props: {
    onImageSelected: {
      type: Function,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    accept: {
      type: String,
      default: "image/*",
    },

    tabindex: {
      type: [String, Number],
      default: 1,
    },

    id: {
      type: String,
      default: () => `app_input_upload_image`,
    },
  },
};
</script>

<style lang="scss" src="./styles.scss" scoped />
